export const COLORS = {
  yellow: "#FFBD12",
  lightYellow: "#F2C94C",
  pink: "rgba(255, 138, 187, 0.84)",
  lightBlue: "#9FD5E3",
  lightSkyBlue: "#E0F4F3",
  pastelBlue: "rgba(25, 71, 229, 0.5)",
  darkBlue: "#4A5DB3",
  orange: "#F95A2B",
  lightGreen: "#00C6AE",
  darkGray: "#333333",
  white: "#f9fcfb",
};

export const FONT_WEIGHT = {
  regular: "400",
  medium: "500",
  semiBold: "600",
  bold: "700",
  extraBold: "800",
};
